<template>
  <div class="add-step">
    <ins-header
      :title="headerTitle"
      :hasVerifi="false"
      @back="goBack"
    ></ins-header>
    <div class="add-card">
      <p class="inv-title">
        همه چیز با دوستان بهتر است. این لینک را برای دوستانت بفرست و اون‌هارو به
        جمع ما دعوت کن:
      </p>
      <img src="@/assets/img/invite_other.svg" />
      <button class="m-btn" style="margin-top: 14px">ارسال برای مخاطبین</button>
      <button class="m-btn" style="margin-top: 14px; background: #030135">
        اشتراک‌گذاری مستقیم از طریق
      </button>
    </div>
  </div>
</template>

<script>
import InsHeader from "../../layouts/inside-header.vue";
export default {
  components: {
    InsHeader,
  },
  computed: {
    headerTitle() {
      return this.$route.meta.prtitle;
    },
  },
  data() {
    return {};
  },
  methods: {
    chenge() {},
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped></style>
